// Declared twice so that docs appear when selecting colors
interface TempusPalette extends Record<string, string> {
  /** **#F5FBFC** - Formerly named "skyBlue". */
  readonly tempus10: string;
  /** **#E2F3F8** - Formerly named "robinBlue". */
  readonly tempus20: string;
  /** **#C3E5F1** - Formerly named "powderBlue". */
  readonly tempus30: string;
  /** **#88CDE3** - Formerly named "seaBlue". */
  readonly tempus40: string;
  /** **#39ABD1** - Formerly named "blue / tempusBlue". */
  readonly tempusPrimary: string;
  /** **#379EC5** - Only use this for active state of primary button */
  readonly tempus55: string;
  /** **#0C80A6** - Formerly named "ceruleanBlue". */
  readonly tempus60: string;
  /** **#0B5973** - Formerly named "royalBlue". */
  readonly tempus70: string;
}

export const tempusPalette: TempusPalette = {
  tempus10: '#F5FBFC',
  tempus20: '#E2F3F8',
  tempus30: '#C3E5F1',
  tempus40: '#88CDE3',
  tempusPrimary: '#39ABD1',
  tempus55: '#379EC5',
  tempus60: '#0C80A6',
  tempus70: '#0B5973',
};
